export const directoryTypes = {
	formula: 'formula',
	dataSource: 'datasource',
	oneOnOneTemplate: 'oneononetemplate',
	report: 'report',
	employee: 'employee',
	employeeInactive: 'employee_inactive',
	employeePending: 'employee_pending',
	employeeTracked: 'employee_tracked',
	slideshow: 'slideshow',
	tv: 'tv',
	reportPinned: 'report_pinned',
	reportScheduled: 'report_scheduled',
	reportDisabled: 'report_disabled',
	achievement: 'achievement',
	contest: 'contest',
	contestFinished: 'contest_finished',
};
